import React from 'react';

import { graphql, useLazyLoadQuery } from 'react-relay';

import type { peopleEntityInlineListRelayQuery } from './__generated__/peopleEntityInlineListRelayQuery.graphql';
import { UserInlinePreviewListRelay } from './lumina-user-inline-preview-list-relay';

export type PeopleEntityInlineListRelayProps = {
	accountIds: string[];
	cloudId: string;
	initialVisibleCount?: number;
	layout?: 'grid' | 'stack';
	maxVisibleItems?: number;
	orgId: string;
	requestingUserId: string;
	testId: string;
};

/**
 * One Relay query for all people in a `<people-entity-list>`
 */
export function PeopleEntityInlineListRelay({
	accountIds,
	cloudId,
	orgId,
	requestingUserId,
	initialVisibleCount,
	layout,
	maxVisibleItems,
	testId = 'lumina-people-entity-list',
}: PeopleEntityInlineListRelayProps): React.JSX.Element {
	const data = useLazyLoadQuery<peopleEntityInlineListRelayQuery>(
		graphql`
			query peopleEntityInlineListRelayQuery(
				$accountIds: [String!]!
				$requestingUserId: String!
				$tenantId: String!
			) {
				knowledgeDiscovery {
					...luminaUserInlinePreviewListRelay_knowledgeDiscovery
						@arguments(
							accountIds: $accountIds
							requestingUserId: $requestingUserId
							tenantId: $tenantId
						)
				}
			}
		`,
		{
			accountIds,
			requestingUserId,
			tenantId: cloudId,
		},
	);

	return (
		<UserInlinePreviewListRelay
			knowledgeDiscoveryFragment={data.knowledgeDiscovery ?? undefined}
			cloudId={cloudId}
			orgId={orgId}
			requestingUserId={requestingUserId}
			testId={testId}
			initialVisibleCount={initialVisibleCount}
			layout={layout}
			maxVisibleItems={maxVisibleItems}
		/>
	);
}
